import { render } from "./rule.vue?vue&type=template&id=49a75bb0&scoped=true"
const script = {}

import "./rule.vue?vue&type=style&index=0&id=49a75bb0&scoped=true&lang=scss"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a75bb0"]])

export default __exports__